import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { unwrapV2, V2ApiResponse } from '../../../shared/utils/v2-api-response.util';
import { BankAccountEntity, BankAccountPayload } from '../models/bank-account-form.model';

@Injectable({ providedIn: 'root' })
export class BankAccountCrudService {
  private readonly baseUrl = `${environment.apiUrl}/api/v2/bank-accounts`;

  constructor(private http: HttpClient) { }

  get(uid: string): Promise<BankAccountEntity> {
    return unwrapV2(firstValueFrom(this.http.get<V2ApiResponse<BankAccountEntity>>(`${this.baseUrl}/${encodeURIComponent(uid)}`)), 'No se pudo cargar la cuenta bancaria');
  }

  create(payload: BankAccountPayload): Promise<void> {
    return unwrapV2(firstValueFrom(this.http.post<V2ApiResponse<string>>(this.baseUrl, payload)), 'No se pudo crear la cuenta bancaria').then(() => undefined);
  }

  update(uid: string, payload: BankAccountPayload): Promise<void> {
    return unwrapV2(firstValueFrom(this.http.put<V2ApiResponse<boolean>>(`${this.baseUrl}/${encodeURIComponent(uid)}`, { ...payload, uid })), 'No se pudo actualizar la cuenta bancaria').then(() => undefined);
  }
}
